export const entityTypes = {
  ORGANIZATION_BEFORE_REPOSITORY: 'before',
  ORGANIZATION_AFTER_REPOSITORY: 'after',
  ORGANIZATION_ALL: 'all',
  REPOSITORY: 'repository',
};
